import React from 'react'
import Footer from './Footer'
import Header from './Header'
import Menu from './Menu'

const Tienda = () => {
  return (
    <div>
        <Header/>
        <Menu/>
        <Footer/>
    </div>
  )
}

export default Tienda